module.exports = __webpack_public_path__ + "img/mockup.5f6d9757.png";